import { useQuery } from '@tanstack/react-query';
import { tokenInspectorApi } from '../api/tokenInspectorApi';
import type { BlacklistStatusView } from '../types/tokenInspector.types';

/**
 * Query: GET /api/eraf/dev/token-inspector/blacklist?jti=...
 * Only fetches when enabled=true (user has submitted a jti).
 */
export function useBlacklistStatus(jti: string, enabled: boolean) {
  return useQuery<BlacklistStatusView, { code: string; message: string }>({
    queryKey: ['tokenInspector', 'blacklist', jti],
    queryFn: () => tokenInspectorApi.getBlacklistStatus(jti),
    enabled: enabled && jti.trim().length > 0,
    retry: false,
    staleTime: 0,
  });
}
